import TimeAgo from '../util/time_ago'

up.compiler('[relative-time]', function(element, { timestamp, highlightFrom }) {
  const time = new Date(timestamp)
  const highlightTime = highlightFrom && new Date(highlightFrom)

  function update() {
    const timeAgo = new TimeAgo(time)
    element.textContent = timeAgo.humanized()

    if (highlightTime && highlightTime <= timeAgo.now) {
      element.classList.add('text-danger', 'fw-bold')
    }
  }

  function getRefreshDelay() {
    const seconds = new TimeAgo(time).beyond(1, 'minute') ? 60 : 1
    return seconds * 1000
  }

  const updateInterval = setInterval(update, getRefreshDelay())
  update()

  return () => {
    clearInterval(updateInterval)
  }
})
